import * as React from 'react';
import { Logo } from '../Logo';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function View(_ref) {
  var showLogo = _ref.showLogo,
    children = _ref.children;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [showLogo && /*#__PURE__*/_jsx(Logo, {}), children]
  });
}